<div class="setup-wrapper">
  <img class="logo" src="../../../assets/svg/FieldEx_Logo_Black_NoBorder.svg" alt="FieldEx Logo" />

  <div class="setup-left">
    <div class="industry-wrapper">
        <h2>Select your industry</h2>
        <p class="subtitle">
            This helps us tailor modules and terminology for your team’s field operations.
        </p>
        <div class="industry-grid">
            <div
                *ngFor="let industry of industryDetail"
                class="industry-card"
                [class.active]="industry.key === selectedIndustry"
                (click)="selectIndustry(industry)">
                
                <img [src]="industry.icon" alt="{{industry.label}}" />
                <div class="industry-text">
                <h4 [ngClass]="{ 'mb-0': !industry.desc }">{{ industry.label }}</h4>
                <p *ngIf="industry.desc">{{ industry.desc }}</p>
                </div>
                <i class="fa-solid fa-circle-check selected-check" *ngIf="industry.key === selectedIndustry"></i>
            </div>
        </div>
        <div class="button-row-outline">
        <button type="button" class="btn-back" (click)="goToPrevious()">Back</button>
        <button type="button" class="btn-next" (click)="goToNext()">Next</button>
        </div>

    </div>

    
      <!-- Optional: Step progress indicator -->
    <div class="step-indicator">
        <div class="steps">
            <span
            class="dot"
            *ngFor="let n of [1, 2, 3]"
            [class.active]="n <= currentStep"
            [@dotAnim]="n === currentStep ? 'active' : 'inactive'">
            </span>
        </div>
        <span class="step-label">Step {{ currentStep }}/3</span>
    </div>
  </div>
  <div class="setup-right" *ngIf="industryDetail.length > 0 && selectedIndustry">
    <div class="img-wrapper">
        <img [src]="selectedPreview" alt="Industry Preview" />
    </div>
  </div>
</div>
